import { render } from "./BaseDivider.vue?vue&type=template&id=f8f912bc&scoped=true"
const script = {}

import "./BaseDivider.vue?vue&type=style&index=0&id=f8f912bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f8f912bc"

export default script